export const TopTen = [
  {
    collectionSymbol: "ink",
  },
  {
    collectionSymbol: "nodemonkes",
  },
  {
    collectionSymbol: "quantum_cats",
  },

  {
    collectionSymbol: "runestone",
  },
  {
    collectionSymbol: "omb",
  },
  {
    collectionSymbol: "blobarmy",
  },
  {
    collectionSymbol: "rsic",
  },
  {
    collectionSymbol: "royals",
  },
  {
    collectionSymbol: "bitcoin-frogs",
  },
  {
    collectionSymbol: "bitcoin-puppets",
  },
];
